<template>
	<div class="xs-12 flex wrap xs-bottom p4">
		<div class="xs-12 flex wrap">
			<div class="xs-12">
				<core-form-input
					componentName="j-base-input-text"
					name="name"
					v-validate="'required'"
					:validationErrors="errors"
					:label="$t('name')"
					v-model="custom.name"
				/>
			</div>
			<div class="xs-12 mt6">
				<core-form-input
					componentName="j-base-input-text"
					name="description"
					v-model="custom.description"
					:label="$t('description')"
					:subheadline="$t('optional')"
				/>
			</div>
			<div class="xs-12 mt6">
				<core-form-input
					componentName="j-base-select"
					name="scalar_type"
					:label="$t('type')"
					:allowSelectNothing="false"
					:options="scalarTypes"
					v-model="custom.scalarType"
				/>
			</div>
		</div>

		<div class="flex xs-between mt6 xs-12">
			<j-button @click="onAdd" size="small">{{
				$t("create_new_benefit")
			}}</j-button>
			<j-button @click="$emit('hide')" size="small" type="bordered">
				{{ $t("cancel") }}
			</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"

export default {
	components: {
		CoreFormInput,
		JButton
	},
	data() {
		return {
			custom: {
				name: null,
				description: null,
				scalarType: "numberValue",
				inputValue: null
			}
		}
	},
	computed: {
		scalarTypes() {
			return [
				{ name: "Number", value: "numberValue" }
				// { name: "String", value: "stringValue" },
				// { name: "Boolean", value: "booleanValue" }
			]
		}
	},
	methods: {
		async onAdd() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			const buildClaimedValue = type => {
				console.log({ type })
				if (type === "stringValue") return ""
				if (type === "numberValue") return 0
				if (type === "booleanValue") return false
				return 0
			}

			// Massage data into proper format
			const output = {
				name: this.custom.name,
				description: this.custom.description,
				claimedValue: {
					[this.custom.scalarType]: buildClaimedValue(this.custom.scalarType)
				}
			}

			this.$emit("addCustomBenefit", output)
		}
	}
}
</script>